export const environment = {
  production: false,
  apiUrl: 'https://api-dev.sunturqoriwasi.com/api',
  culqi: {
    publicKey: 'pk_test_e1Tb9KmY0EvnF3Ty', // Reemplazar con tu llave pública de prueba
    rsaPublicKeyId: '', // ID de llave pública RSA (configurar desde panel Culqi)
    rsaPublicKey: '',   // Llave pública RSA (configurar desde panel Culqi)
  }
};
